import { Select } from 'antd';
import { useOrgConfig } from './Hooks/OrgConfigHooks';


const AmountFieldSelect = ({ value = null, onChange }) => {
    const orgConfig = useOrgConfig();

    // Without VAT both options are the same number -- the control is pure noise.
    if (!orgConfig.tax_enabled) return null;

    const handleChange = (val) => {
        onChange?.(val);
    };

    return (
        <Select
            showSearch
            placeholder="Izberi znesek"
            optionFilterProp="label"
            options={[
                {
                    'label': 'Znesek brez DDV',
                    'value': 'amount_no_tax'
                },
                {
                    'label': 'Znesek z DDV',
                    'value': 'amount'
                }
            ]}
            value={value}
            onChange={handleChange}
        />
    );
}

export default AmountFieldSelect;
